const version = '1.0.6';
const release = '17.11.2020';

const fs = window.require && window.require('fs');
const path_ = window.require && window.require('path');

const crypto = window.require && window.require('crypto');
const exec = window.require && window.require('child_process').exec;

const exifParser = null;

const BUFFER_SIZE = 8192;
const EXIF = null;


const fileExcludes = [
	'Thumbs.db'
]

//============================================================================= FileManager
export class fm{
	static settings = {
		exportQuality	: 0.9,
	}
	static downloadPath = '';			//default download path (require '/' as last character!)


	//------------------------------------------------------------------------- getFileCmd
	static getFileCmd = (folder, callback) => {
		if (!exec) return callback && callback(null);

		if (!folder.endsWith('/')) folder += '/';
		// let cmd = 'dir /A-D /-C /N /4 /ON ' + folder.replace(/\//g, '\\');
		// ---switch to active codepage 65001 for unicode file names: https://stackoverflow.com/questions/379240/is-there-a-windows-command-shell-that-will-display-unicode-characters/24135341#24135341
		let cmd = 'CHCP 65001 | dir /A-D /-C /N /4 /ON ' + folder.replace(/\//g, '\\');
		// let cmd = 'CHCP 65001 | dir /-C /N /4 /ON ' + folder.replace(/\//g, '\\');

		exec(cmd, (error, stdout, stderr) => {
			if (error) {
				console.error(`error: ${error}`);
				return callback && callback(null);
			}
			if (stderr){
				console.log(`error: ${stderr}`)
				return callback && callback(null);
			}

			let list = stdout.split('\r\n').filter(e => e !== '' && e.substr(0, 1) !== ' ');

			// let dir = {
			// 	name: '',
			// 	path: '',
			// 	files: [],
			// 	folders: [],
			// }
			// return(callback && callback(dir));

			// let list = stdout.split('\r\n').filter(e => e !== '' && e.substr(0, 1) !== ' ');

			list = list.filter(e => {
				let name = e.substr(36);
				return !fileExcludes.includes(name);

			}).map(e => {
				let name = e.substr(36);
				let time = Date.parse(e.substr(6, 4) + '-' + e.substr(3, 2) + '-' + e.substr(0, 2) + ' ' + e.substr(12, 5));
				return {
					_cid: 'file-item',
					name,
					path: folder + name,
					type: name.substr(name.lastIndexOf('.') + 1),
					size: Number(e.substr(18, 17)),
					time
				}
			})

			// list = list.map(e => {
			// 	let name = e.substr(36);
			// 	let time = Date.parse(e.substr(6, 4) + '-' + e.substr(3, 2) + '-' + e.substr(0, 2) + ' ' + e.substr(12, 5));
			// 	return {
			// 		_cid: 'file-item',
			// 		name,
			// 		path: folder + name,
			// 		type: name.substr(name.lastIndexOf('.') + 1),
			// 		size: Number(e.substr(18, 17)),
			// 		time
			// 	}
			// })
			
			return(callback && callback(list));
		});
	}


	//------------------------------------------------------------------------- md5FileSync
	// https://github.com/roryrjb/md5-file/blob/master/index.js

	static md5FileSync (filename) {
		const fd = fs.openSync(filename, 'r');
		const hash = crypto.createHash('md5');
		const buffer = Buffer.alloc(BUFFER_SIZE);
	
		try {
			let bytesRead;
			do {
				bytesRead = fs.readSync(fd, buffer, 0, BUFFER_SIZE)
				hash.update(buffer.slice(0, bytesRead))
			} while (bytesRead === BUFFER_SIZE)
		} finally {
			fs.closeSync(fd)
		}
	
		return hash.digest('hex');
	}

/* ---try
	//https://nodejs.org/api/crypto.html#crypto_crypto_createhash_algorithm_options
const hash = crypto.createHash('sha256');

const input = fs.createReadStream(filename);
input.on('readable', () => {
  // Only one element is going to be produced by the
  // hash stream.
  const data = input.read();
  if (data)
    hash.update(data);
  else {
    console.log(`${hash.digest('hex')} ${filename}`);
  }
});
*/


	//------------------------------------------------------------------------- md5File
	static md5File (filename, callback) {
		if (typeof callback !== 'function') throw new TypeError('Argument cb must be a function');
	  
		const output = crypto.createHash('md5');
		const input = fs.createReadStream(filename);
	  
		input.on('error', function (err) {
			callback(err)
		})
	
		output.once('readable', function () {
			callback(null, output.read().toString('hex'))
		})
	
		input.pipe(output);
	}
	  

	//------------------------------------------------------------------------- readFolder
	// return a list of all file- or folder-names incl. full path
	static readFolder(folder='../', ext='*', type='*'){
		/**
		 * ext: filter e.g. '.jpg' or ['.jpg', '.png'] or '*' for all files
		 * type: folder, file, *
		 */
		// try{
		// 	if (!fs.statSync(folder).isDirectory()) return 'folder error';
		// }catch(err){
		// 	return err;
		// }

		if (folder.substring(folder.length-1) !== '/') folder += '/';
		let fileList = [];

		let files = fs.readdirSync(folder);
		files.map(file => {
			return path_.join(folder, file);

		}).filter(file => {
			if (type === '*') return true;
			let stat = fs.statSync(file);
			if (type === 'file' && stat.isFile()) return true;
			if (type === 'folder' && stat.isDirectory()) return true;
			return false;

		}).forEach(file => {
			let ex = path_.extname(file);
			if (ext === '*' || ext === ex || (Array.isArray(ext) && ext.find(e => e === ex))){
				fileList.push( file.replace(/\\/g, "/") );		//replace '\' with '/'
				// fileList.push( file );
			}
		});

		return fileList;
	}


	//------------------------------------------------------------------------- getFileList
	// set a number for recursive deep level
	//
	static getFileList(folder, includePath=true, recursive=true, _level=0){
		if (!folder) return null;
		let files = {};
		if (folder.substr(folder.length-1) !== '/') folder += '/';
	
		try {
			fs.readdirSync(folder).forEach(name => {
				let path = folder + name;
				let stat;
				try {
					stat = fs.statSync(path);
				} catch (error) {
					console.error('file error:', path);
					return;
				}
	
				let file = includePath? path : name;
	
				if (stat.isDirectory() && (recursive === true || recursive > _level)){
					files[file] = this.getFileList(path+'/', includePath, recursive, _level + 1);

				}else if (stat.isFile()) files[file] = [stat.size, stat.birthtime];

			});
		} catch (error) {
			console.error('folder error:', folder);
		}
	
		return files;
	}


	//------------------------------------------------------------------------- getFileTree
	// deep = true or limited to a number of levels
	//
	static getFileTree(folder, deep=true, excludes, _level=0){
		if (!folder) return null;

		let name = path_.basename(folder);
		folder = path_.dirname(folder) + '/';
		let _path = folder + name + '/';

		let node = {
			// stat		: fs.statSync(folder),
			type		: 'folder',
			name,
			path		: _path,
			files		: [],
			numFiles	: 0,
			fileSize	: 0,
			folders		: [],
			numFolders	: 0,
			totalFolders: 0,
			totalFiles	: 0,		//total number of files in this folder incl. all sub-folders
			totalSize	: 0,
			errors		: [],
			numErrors	: 0,
			totalErrors	: 0,
		}

		try {
			let stat = fs.statSync(folder);
			node.created = stat.birthtime;
			node.changed = stat.mtime;
	
			fs.readdirSync(_path).forEach(name => {
				let __path = _path + name + '/';
				try {
					stat = fs.statSync(__path);
				
				} catch (error) {
					node.errors.push({
						name,
						path	: __path,
						error	: error
					})
					node.numErrors ++;
					return;
				}
	
				if (stat.isDirectory()){
					if (deep === true || deep > _level){
						let fldr = this.getFileTree(__path, deep, excludes, _level + 1);
						node.folders.push(fldr);
						node.totalFolders += fldr.totalFolders;
						node.totalFiles += fldr.totalFiles;
						node.totalSize += fldr.totalSize;

					}else{
						node.folders.push({
							type	: 'folder',
							name,
							path	: __path,
							created	: stat.birthtime,
							changed : stat.mtime,
						})
					}
				}
				else if (stat.isFile()){
					node.files.push({
						// stat,
						type	: 'file',
						name,
						ext		: name.split('.').pop(),
						path	: __path.substring(0, __path.length - 1),	//remove last '/'
						size	: stat.size,
						created	: stat.birthtime,
						changed : stat.mtime,
					});
					node.fileSize += stat.size;
					node.totalSize += stat.size;
				}
			});
				
		} catch (error) {
			node.errors.push({error})
			node.numErrors ++;
		}

		node.numFiles = node.files.length;
		node.totalFiles += node.numFiles;
		node.numFolders = node.folders.length;
		node.totalFolders += node.numFolders;
		node.totalErrors += node.numErrors;

		return node;
	}


	//------------------------------------------------------------------------- getFileStat
	static getFileStat(file){
		if (!fs.existsSync(file)) return null;		//file or folder not exists

		try {
			let folder	= path_.dirname(file);
			let name	= path_.basename(file);			//the file|folder name only
			let ext		= path_.extname(file);
			let path	= folder + name;
			let stat	= fs.statSync(path);
			let type	= stat.isDirectory()? 'folder' : stat.isFile()? 'file' : 'unknown';
			let drive	= folder.split('/')[0];

			return {
				type,
				name	: name || folder,
				ext,
				path	: path + (type === 'folder'? '/' : ''),
				drive,
				size	: stat.size,
				created	: stat.birthtime,
				changed : stat.mtime,
			}
		} catch (error) {
			return error
		}
	}


	//------------------------------------------------------------------------- saveBlob
	static saveBlob(file, blob){
		let fileReader = new FileReader();
		fileReader.onload = function () {
			fs.writeFileSync(file, Buffer(new Uint8Array(this.result)));
		};
		fileReader.readAsArrayBuffer(blob);
	}

	
	//------------------------------------------------------------------------- saveData
	// html downloading (https://stackoverflow.com/questions/45239154/saving-an-image-blob)
	static saveData(data, fileName){
		let json = JSON.stringify(data);
		let file = new Blob([json], {type: "octet/stream"});
		let url = URL.createObjectURL(file);
		let a = document.createElement("a");
		a.href = url;
		a.download = fileName;
		a.click();
		window.URL.revokeObjectURL(url);
	};


	//------------------------------------------------------------------------- saveJson
	static saveJson(file, data, form=false){
		if (!this.createPath(file)){
			console.error('error on saving json data at', file)
			return null;		//return if path can't create
		}
		return fs.writeFileSync(file, JSON.stringify(data, null, form? '\t' : null));
	}


	//------------------------------------------------------------------------- writeJson
	static async writeJson(file, json, form=true){
		return new Promise(function(resolve, reject){
			fs.writeFile(file, JSON.stringify(json, null, form? '\t' : null), null,
			exists => resolve(exists))
		})
	}


	//------------------------------------------------------------------------- readJson
	static readJson(file){
		if (!this.exists(file)) return null;
		try{
			let json = JSON.parse(fs.readFileSync(file, 'utf8'));
			return json;
		}catch(err){
			return null;
		}
	}


	//------------------------------------------------------------------------- copy
	static copy(from, to){
		return fs.copyFileSync(from, to);
	}


	//------------------------------------------------------------------------- move
	static move(from, to){
		// fs.rename(from, to);		//cross-device link not permitted
		if (!fs.existsSync(from)) return
		fs.copyFileSync(from, to);
		if (fs.existsSync(to)) fs.unlinkSync(from);		//remove only if copy was success
		// fs.rmdirSync(folder);	//remove a folder
		return;
	}
	
	
	//------------------------------------------------------------------------- exists
	static exists(file){
		return fs.existsSync(file);
	}


	// //------------------------------------------------------------------------- getExif
	// static getExif(){

	// }


	//----------------------------------------------------------------------------- getUrlFileName
	static getUrlFileName(url, inclExt=true){
		if (!url) return null;
		let matches = url.match(/\/([^\/?#]+)$/);
		let name = matches ? matches[1] : url;
		if (name && !inclExt) name = name.substr(0, name.lastIndexOf('.')) || name;
		return name;
	}


	//----------------------------------------------------------------------------- getUrlFileName
	static getFileName(path){
		let last = path.lastIndexOf('/') + 1;
		return path.substr(last);
	}


	//----------------------------------------------------------------------------- getFileType
	// https://jsperf.com/extract-file-extension
	static getFileType(path){
		return path.substr((~-path.lastIndexOf('.') >>> 0) + 2);
	}
	

	//----------------------------------------------------------------------------- getDownloadPath
	// get full local filePath to download
	static getDownloadPath(fileName, path){
		if (!path) return this.downloadPath + fileName;	//default path

		if (path.slice(0,2) === './'){
			path = this.downloadPath + path.slice(2);	//use default downloadPath
		}
		if (path.slice(-1) === '/'){	//path is only a folder with no filename
			return path + fileName;	//full path and filename
		}else{						//path has a filename included
			return path;			//take the full path include filname as it is
		}
	}

	//----------------------------------------------------------------------------- download
	// todo:
	//		use props
	//		check result
	//		add progress event
	static download(url, path='./', callback = e => {}, overwrite=false){
		if (!fs) return

		if (!window.require) return console.error('not a node environment!');

		let fileName = (path.slice(-1) === '/')
			? this.getUrlFileName(url)					//get file name from url
			: path.slice( path.lastIndexOf('/') + 1 );	//or get file name from path

		fileName = decodeURI(fileName);		//the local file is always url decoded!
		
		let filePath = this.getDownloadPath(fileName, path);
		this.createPath(filePath);						//create filePath if not exists

		if (!overwrite && fs.existsSync(filePath)) return callback(null);

		// console.log('download', filePath, 'from', url, '...');
// request(url).pipe(fs.createWriteStream(filePath)).on('close', callback);
	}


	//------------------------------------------------------------------------- createPath
	static createPath(dir){
		if (!fs) return null

		if (dir.slice(-1) !== '/') dir = path_.dirname(dir);
		if (fs.existsSync(dir)) return dir

		let path = dir.split('/');
		let p = '';
		try{
			path.forEach(val => {
				if (val !== '' && val !== '.'){
					p += val + '/';
					if (!fs.existsSync(p)) fs.mkdirSync(p);		//create subfolder if not exists
				}
			});
		}catch(err){
			return null
		}
		return fs.existsSync(dir)? dir : null
	}


	//------------------------------------------------------------------------- convertImageFile
	static convertImageFile(source, target, quality, callback){
		this.createPath(target);
		
		if (!this.canvas) this.canvas = document.createElement('canvas');

		let image = new Image();
		image.onload = e => {
			this.canvas.width = image.width
			this.canvas.height = image.height
			let ctx = this.canvas.getContext('2d');
			ctx.drawImage(image, 0, 0);

			this.saveCanvas(this.canvas, target, quality);
			if (callback) callback(e);
		}
		image.onerror = e => {
			console.log('convertImageFile error', source);
			if (callback) callback(e);
		}

		image.src = source;
	}


	//------------------------------------------------------------------------- saveCanvas
	static saveCanvas(canvas, file, quality){
		let ext = file.slice(file.lastIndexOf('.'));
		let q = quality || this.settings.exportQuality;

		this.createPath(file);	//create path if not exists

		let dataUrl = ext === '.png'?
			canvas.toDataURL().replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
			: ext === '.jpg'?
			canvas.toDataURL('image/jpeg', q).replace(/^data:image\/jpeg;base64,/, '')
			: ext === '.webp'?
			canvas.toDataURL('image/webp', q).replace(/^data:image\/webp;base64,/, '')
			: null;

		if (dataUrl) fs.writeFileSync(file, dataUrl, 'base64');
		else console.log('saveCanvas error:', file);
	}


	//------------------------------------------------------------------------- creteThumbFromFile
	static creteThumbFromFile(file){
		if (!fs || !exifParser) return null;
		if (!fs.existsSync(file)) return null;
		
		let buf = fs.readFileSync(file);
		let parser = exifParser.create(buf).enableReturnTags(false);
		let result
		try{
			result = parser.parse();
		}catch(err){
			console.log('parse-error!', file); //, err);
			return null;
		}

		let imageUrl;
		if(!result.hasThumbnail('image/jpeg')) {
			// console.log('no jpeg thumbnail in:', file);
			imageUrl = file;

		} else {
			let buffer = result.getThumbnailBuffer();
			let blob = new Blob( [buffer], {type:'image/jpeg'} );
			let urlCreator = window.URL || window.webkitURL;
			imageUrl = urlCreator.createObjectURL( blob );
		}

		return imageUrl;
	}
	

	//------------------------------------------------------------------------- getExif
	static async getExif(url){
		if (!EXIF) return;

		let data = await ( await fetch(url) ).arrayBuffer();
		if (!data) return null;

		let exif = EXIF.readFromBinaryFile(data);
		// let exif = exifParser.create(data).enableReturnTags(true).parse();
		// console.log('EXIF:', exif);
		return exif;
	}


	//------------------------------------------------------------------------- getExifImageSize
	static async getExifImage(file){
		if (!fs || !exifParser) return null;
		// if (!fs.existsSync(file)) return null;
		
		let buf = fs.readFileSync(file);
		let parser = exifParser.create(buf);//.enableImageSize(true);

		try {
			return parser.parse();
		} catch (error) {
			return null;
		}
	}
	

	//------------------------------------------------------------------------- getExifOrientation
	static getExifOrientation(file){
		// let data = await ( await fetch(url) ).arrayBuffer();
		// if (!data) return null;
		let data = fs.readFileSync(file).buffer;

		let view = new DataView(data);
		let o = this.parseExifOrientation(view);

		// console.log('---exif-orientation:', o);
		return o;	//-1 - 7
	}

	//------------------------------------------------------------------------- parseExifOrientation
	static parseExifOrientation = (view) => {
		let length = view.byteLength,
		offset = 2;
	
		while (offset < length) {
			let marker = view.getUint16(offset, false);
			offset += 2;
	
			if (marker === 0xffe1) {
				if (view.getUint32((offset += 2), false) !== 0x45786966) {
					return -1;
				}
				let little = view.getUint16((offset += 6), false) === 0x4949;
				offset += view.getUint32(offset + 4, little);
				let tags = view.getUint16(offset, little);
				offset += 2;
	
				for (let i = 0; i < tags; i++){
					if (view.getUint16(offset + i * 12, little) === 0x0112)
					return (view.getUint16(offset + i * 12 + 8, little));
				}
	
			} else if ((marker & 0xff00) !== 0xff00) break;
	
			else offset += view.getUint16(offset, false);
		}
	
		return -1;
	};

	
	//------------------------------------------------------------------------- fixExifOrientation
	static fixExifOrientation(file){
		if (!fs.existsSync(file)) return;		//wrong file

		let data = fs.readFileSync(file).buffer;

		let view = new DataView(data);
		let o = this.parseExifOrientation(view);
		if (!o || o < 2) return;

		let orientation = orientations[o];
		if (!orientation) return;

		console.log('---fix image orientation:', orientation, file, '...');

		let image = new Image();
		image.src = URL.createObjectURL(new Blob([data], {type: 'image/jpeg'}));
		image.onload = e => {
			let canvas = this.translateImage(image, orientation);
			this.saveCanvas(canvas, file, 0.9);
			console.log('   image replaced!', file);
		}
	}

	//------------------------------------------------------------------------- translateImage
	static translateImage(image, orientation) {
		orientation = orientation || {};
	
		let c = document.createElement('canvas');
		let ctx = c.getContext('2d');
	
		if (Math.abs(orientation.rotate === 90)){
			c.width = image.naturalHeight;
			c.height = image.naturalWidth;
		}else{
			c.width = image.naturalWidth;
			c.height = image.naturalHeight;
		}
		let w = c.width;
		let h = c.height;
		
		if (orientation.scale.x === -1 && orientation.scale.y === -1) {
			ctx.translate(w,h);
			ctx.scale(orientation.scale.x,orientation.scale.y);
	
		} else if (orientation.scale.x !== 1) {
			ctx.translate(w,0);
			ctx.scale(orientation.scale.x,1);
	
		} else if (orientation.scale.y !== 1) {
			ctx.translate(0,h);
			ctx.scale(1,orientation.scale.y);
		}
		if (orientation.rotate) {
			// ctx.rotate(30 * (Math.PI / 180));
			// ctx.translate(w*0.2,h*0.2);
	
			// ctx.translate(w*0.5,h*0.5);
			ctx.rotate(orientation.rotate * (Math.PI / 180));
			// ctx.translate(-w*0.5,-h*0.5);
			ctx.translate(0, -w);
		}
		// ctx.drawImage(image,0,0,image.naturalWidth,image.naturalHeight,0,0,w,h);
	
		// ctx.drawImage(image, 0, 0, w, h, (h-w)/-2, (w-h)/-2, w, h);
		// ctx.drawImage(image, 0, 0, w, h, (h-w)/-2, (w-h)/-2, w, h);
		// ctx.drawImage(image, 0, 0, h, w, (w-h)/2, (h-w)/2, h, w);
		ctx.drawImage(image, 0, 0, h, w);
		return c;
	};

	
}


const orientations = [
	{ scale: {x: 1, y: 1}, rotate: 0 },
	{ scale: {x: 1, y: 1}, rotate: 0 },
	{ scale: {x: -1, y: 1}, rotate: 0 },
	{ scale: {x: 1, y: 1}, rotate: 180 },
	{ scale: {x: 1, y: -1}, rotate: 0 },
	{ scale: {x: -1, y: 1}, rotate: 90 },
	{ scale: {x: 1, y: 1}, rotate: 90 },
	{ scale: {x: -1, y: 1}, rotate: -90 },
	{ scale: {x: 1, y: 1}, rotate: -90 }
];

